import { CalculationStrategies } from '../../@types/samples/types';

/**
 * Editable fields exposed on the Samples Summary page. `sample_code` and `depth`
 * map to top-level `UpdateSamplePayload` fields; the rest are nested under
 * `input_sample_values`.
 */
export type EditableField =
  | 'sample_code'
  | 'depth'
  | 'porosity'
  | 'permeability'
  | 'ko'
  | 'krw'
  | 'qv'
  | 'swi'
  | 'salinity';

/**
 * Flat row model derived from a `ProjectSample`. Numeric fields hold raw values
 * (formatting happens at render time); `uid === AVERAGE_ROW_UID` marks the
 * synthetic per-group average row, which is never editable or saved.
 */
export interface SummaryRow {
  uid: string;
  well_uid: string;
  wellName: string;
  analyses: CalculationStrategies[];
  depth_unit: 'm' | 'ft';

  // editable
  sample_code: string;
  depth: number | null;
  porosity: number | null;
  permeability: number | null;
  ko: number | null;
  krw: number | null;
  qv: number | null;
  swi: number | null;
  salinity: number | null;

  // calculated / read-only
  fzi: number | null;
  kro_absolute: number | null;
  krw_absolute: number | null;
  krg_absolute: number | null;
  sor_w: number | null;
  no_w: number | null;
  nw: number | null;
  true_sor_w: number | null;
  true_no_w: number | null;
  true_nw: number | null;
  true_krw: number | null;
  true_kro_w: number | null;
  sor_g: number | null;
  no_g: number | null;
  ng: number | null;
  true_sor_g: number | null;
  true_no_g: number | null;
  true_ng: number | null;
  true_krg: number | null;
  true_kro_g: number | null;

  /** True only for the synthetic average row. */
  isAverage?: boolean;
}

export const AVERAGE_ROW_UID = '__average__';

export type GroupMode = 'none' | 'well' | 'analysis' | 'well-analysis';
